import { AxiosRequestConfig } from 'axios'

export interface TicketScanStatsParams {
  startDate: string
  endDate: string
  storeIds?: string
}

export interface TicketStats {
  physicalTickets: number
  appScans: number
  percentage: number
  month: number
  year: number
}

export interface TicketScanStatsResponse {
  data: TicketStats[]
}

const uploadPhysicalTickets = (fileContent: string): AxiosRequestConfig => ({
  url: '/physical-tickets/upload',
  method: 'POST',
  data: { file: fileContent },
})

const getTicketScanStats = (params: TicketScanStatsParams): AxiosRequestConfig => ({
  url: '/dashboard/tickets/scan-stats',
  method: 'GET',
  params,
})

export { uploadPhysicalTickets, getTicketScanStats }
